module.exports = __webpack_public_path__ + "img/return-flow-lg.f8937683.svg";